import React from 'react'
import PagePreviousIcon from '@rsuite/icons/PagePrevious'
import PageNextIcon from '@rsuite/icons/PageNext'

type Props = {
  page: number
  size: number
  total: number
  sizes?: number[]
  onPage: (page: number) => void
  onSize: (size: number) => void
}

/** "Page X of Y · N total" with rows-per-page and prev/next. Page is 0-based. */
const Pagination: React.FC<Props> = ({
  page,
  size,
  total,
  sizes = [20, 50, 100],
  onPage,
  onSize
}) => {
  const pages = Math.max(1, Math.ceil(total / size))
  return (
    <div className="dx-pager">
      <span className="dx-pager__summary">
        Page {Math.min(page + 1, pages)} of {pages} · {total.toLocaleString()}{' '}
        total
      </span>
      <div className="dx-pager__controls">
        <label className="dx-pager__size" htmlFor="dx-page-size">
          Rows
          <select
            id="dx-page-size"
            value={size}
            onChange={(e) => onSize(Number(e.target.value))}
            aria-label="Rows per page"
          >
            {sizes.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </label>
        <button
          type="button"
          className="dx-icon-btn"
          disabled={page <= 0}
          onClick={() => onPage(page - 1)}
          aria-label="Previous page"
        >
          <PagePreviousIcon />
        </button>
        <button
          type="button"
          className="dx-icon-btn"
          disabled={page + 1 >= pages}
          onClick={() => onPage(page + 1)}
          aria-label="Next page"
        >
          <PageNextIcon />
        </button>
      </div>
    </div>
  )
}

export default Pagination
